import script from "./BaseModalComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModalComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModalComponent.vue?vue&type=style&index=0&id=054fd0fa&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054fd0fa"]])

export default __exports__